import { Button } from 'antd';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Assets } from '../../assets';
import { Constants, isAdmin, PortalVersions } from '../../constants/general.constant';

export const LoginScreen = () => {
    const navigate = useNavigate();
    const versionLabel = process.env.REACT_APP_MODE === Constants.ADMIN ? `Version ${PortalVersions.ADMIN}` : `Version ${PortalVersions.CLIENT}`;
    return <div className='flex flex-col justify-center items-center px-6' style={{ minHeight: '100vh', width: '100vw', backgroundImage: `url(${Assets.LoginBG})`, backgroundSize: 'cover' }}>
        <div className='flex flex-1 flex-col gap-5 justify-center items-center'>
            <img src={Assets.Logo} className="object-contain w-52 h-32" alt="" />
            <div className='text-white bg-primary-orange px-12 py-3'>
                Welcome To Your <span className='text-black'>{isAdmin && "Admin"} Portal</span>
            </div>
            <span className='text-white'>
                Safe, trust worthy and money saving driver services.
            </span>
            <div className='flex flex-row gap-5'>
                <Button onClick={navigate?.bind(this, '/sign-in')} className='w-32' type='primary'>Login</Button>
            </div>
        </div>
        <div className='pb-6 text-sm font-medium text-white/90'>
            {versionLabel}
        </div>
    </div>
}
